<template>
  <span
    class="swatch"
    :style="{
      background: SeatStatusColors[status].background,
      borderColor: SeatStatusColors[status].border,
      color: SeatStatusColors[status].color,
    }"
  >
    <i v-if="SeatStatusIcons[status]" :class="SeatStatusIcons[status]" />
  </span>
</template>

<script lang="ts" setup>
// A small seat painted like the grid paints this status, for the legend and the counts
import { SeatStatusColors, SeatStatusIcons, type SeatStatus } from '@/constants/SeatStatuses'

interface Props {
  status: SeatStatus
}

const { status } = defineProps<Props>()

defineOptions({ name: 'SeatStatusSwatch' })
</script>

<style scoped>
.swatch {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid;
  border-radius: 5px 5px 2px 2px;
  font-size: 9px;
}
</style>
